let styledata4 =[
    {
        id : 68,
        imgurl : 'img/section6/section6_13.jpg',
        text : '@its_me_sh'
    },
    {
        id : 69,
        imgurl : 'img/section6/section6_14.jpg',
        text : '@sssssun_yyy'
    },
    {
        id : 70,
        imgurl : 'img/section6/section6_15.jpg',
        text : '@lcylcylc'
    },
    {
        id : 71,
        imgurl : 'img/section6/section6_16.jpg',
        text : '@da._.woooooon'
    },
]

export default styledata4;